// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDERvmZGm1fjucEIRmRq_zyyKFkL0KYHTI",
  authDomain: "madetest-81fde.firebaseapp.com",
  projectId: "madetest-81fde",
  storageBucket: "madetest-81fde.firebasestorage.app",
  messagingSenderId: "785673047492",
  appId: "1:785673047492:web:9281c0468647f3cee76891",
  measurementId: "G-7S8ZK6R35D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(
  app,
  "gs://madetest-81fde.firebasestorage.app"
);
export default app;